import { ClickAwayListener } from '@mui/material';
import { cloneElement } from 'react';

import { usePopoverContext } from './context';

import type { FC, ReactElement } from 'react';

export interface PopperOnClickCloseProps {
  children: ReactElement;
}

export const PopoverClickAwayClose: FC<PopperOnClickCloseProps> = ({
  children,
  ...props
}) => {
  const { handleClose } = usePopoverContext();

  return (
    <ClickAwayListener onClickAway={handleClose}>
      {cloneElement(children, {
        onClick: handleClose,
        ...props,
      })}
    </ClickAwayListener>
  );
};
